import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";
import type { TopImagePartProps } from "./TopImage.d";

export const TopImagePart = (props: ComponentProps<PartData>) => {
  const { background, imageCaption, imageUrl, imageAlt } =
    (props.data as TopImagePartProps) ?? {};

  return (
    <section className={background === "red" ? "bg-red-25" : ""}>
      <div className="article-image">
        <figure>
          <img src={imageUrl} alt={imageAlt} />
          <figcaption>{imageCaption}</figcaption>
        </figure>
      </div>
    </section>
  );
};

export default TopImagePart;
